<template lang="">
  <div 
  v-if="$store.state.permissions.showWhizz"
  class="flex flex-col w-screen h-screen">
    <div class="w-full">
      <div
        class="lg:flex lg:items-center lg:justify-between my-4 lg:mx-12 mx-12"
      >
        <div class="flex justify-center lg:justify-start mt-4 min-w-0">
          <div>
            <h2
              class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate"
            >
              Search Name
            </h2>
          </div>
        </div>
      </div>
      <div class="flex flex-row w-full mt-8 items-center justify-center">
        <div class="border-b-2 mx-2">
          <input
            v-model="firstName"
            type="text"
            id="first_name"
            class="place-self-center h-full bg-gray-50 text-gray-900 text-sm rounded-lg block p-2.5"
            placeholder="First Name"
            required
          />
        </div>
        <div class="border-b-2">
          <input
            v-model="lastName"
            type="text"
            id="last_name"
            class="place-self-center h-full bg-gray-50 text-gray-900 text-sm rounded-lg block p-2.5"
            placeholder="Last Name"
            required
          />
        </div>
        <div>
          <ul
            class="items-center text-sm font-medium text-gray-900 bg-white rounded-lg sm:flex"
          >
            <li class="w-full">
              <div class="flex items-center pl-3">
                <input
                  v-model="searchType"
                  type="radio"
                  id="LOOK_ALIKE"
                  value="LOOK_ALIKE"
                  name="list-radio"
                  class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                  checked
                />
                <label
                  for="LOOK_ALIKE"
                  class="py-3 ml-2 w-full text-sm font-medium text-gray-900"
                  >Look Alike
                </label>
              </div>
            </li>
            <li class="w-full">
              <div class="flex items-center pl-3">
                <input
                  id="EXACT_MATCH"
                  v-model="searchType"
                  type="radio"
                  value="EXACT_MATCH"
                  name="list-radio"
                  class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                />
                <label
                  for="EXACT_MATCH"
                  class="py-3 ml-2 w-full text-sm font-medium text-gray-900"
                  >Exact Match</label
                >
              </div>
            </li>

            <li class="w-full">
              <div class="flex items-center pl-3">
                <input
                  v-model="searchType"
                  type="radio"
                  value="PHONETIC_RESULT"
                  name="list-radio"
                  class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                />
                <label
                  class="py-3 ml-2 w-full text-sm font-medium text-gray-900"
                  >Phonetic Result</label
                >
              </div>
            </li>
            <div
              class="mt-4 gap-3 w-min flex flex-col justify-center md:flex-row lg:mt-0 lg:ml-4"
            >
              <button
                class="py-2 px-4 mt-2 mx-2 bg-woo rounded-lg text-white font-semibold"
                @click="search()"
              >
                Search
              </button>
            </div>
          </ul>
        </div>
      </div>
    </div>

  <GoodTable
        v-if="blackList.length"
        :name="'whizz'"
        :rows="blackList"
        :columns="columns"
      />

  </div>
</template>
<script>
import Http, { OCR_ENDPOINTS } from "../request";
import GoodTable from "../components/GoodTable.vue";

export default {
  created() {},

  components: {
    GoodTable
  },

  data() {
    return {
      firstName: null,
      lastName: null,
      searchType: "LOOK_ALIKE",
      blackList: [],
       columns: [
        {
          label: "ID",
          field: "uid",
          type: "number",
        },
        {
          label: "First Name",
          field: "firstName",
        },
        {
          label: "Last Name",
          field: "lastName",
        },
        {
          label: "Birth Date",
          field: "ageDate",
        },
        {
          label: "Companies",
          field: "companies",
        },
        {
          label: "Aliases",
          field: "aliases",
        },
        {
          label: "Locations",
          field: "locations",
        },
        {
          label: "Countries",
          field: "countries",
        },
        {
          label: "Category",
          field: "category",
        },
        {
          label: "Entered",
          field: "entered",
        },
        {
          label: "Updated",
          field: "updated",
        },
         {
          label: "Further Information",
          field: "viewInformation",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    search() {
      Http()
        .get(OCR_ENDPOINTS.aml, {
          params: {
            firstname : this.firstName,
            lastname : this.lastName,
            searchType : this.searchType,
          },
        })
        .then((response) => {
          this.blackList = response.data.blackListed;
          console.log(response.data.blackListed);
        })
        .catch((error)=>{
          console.log(error.message);
          this.$toast.error(error.message);

        })
        .finally(() => {});
    },
  },
};
</script>
<style lang=""></style>
